import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CLAIMREQUESTS_FEATURE_KEY,
  initialState as claimRequestsInitialState,
  claimRequestsReducer
} from './+state/claim-requests.reducer';
import { ClaimRequestsEffects } from './+state/claim-requests.effects';
import { ClaimRequestsFacade } from './+state/claim-requests.facade';
import { PolicyHoldersService } from '@ecosure-suite/back-office/individuals/policy-holders/data-access-policy-holders';
import { NotificationsService } from '@ecosure-suite/shared/utils-notifications';
import { ClaimDetailsRequestResolverService } from './resolvers/claim-details-resolver';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(CLAIMREQUESTS_FEATURE_KEY, claimRequestsReducer),
    EffectsModule.forFeature([ClaimRequestsEffects])
  ],
  providers: [ClaimRequestsFacade, NotificationsService, ClaimDetailsRequestResolverService]
})
export class BackOfficeClaimsClaimRequestsDataAccessClaimRequestsModule {}
